module.exports = __webpack_public_path__ + "static/media/ic-close-gray.e70999a0.svg";